import { ColumnConfig } from "./ColumnConfig";
import { FilterColumn } from "./FilterColumn";

export class CrudListConfiguration
{
    constructor
    (
        public columnConfig: Array<ColumnConfig>,
        public filterConfig: Array<FilterColumn>,
        public sortBy:string,
        public sortDir:string,
        public maxPerPage:number,
        public listClass:any,
        public allowEdit:boolean,
        public allowShow:boolean,
        public allowDelete:boolean,
        public allowAddNew:boolean=true,
        public customObjectActions:Array<CrudListObjectAction>=[],
        public customActions:Array<any>=[]
    ){ }
}

export class CrudListObjectAction
{
    constructor(
        public title:string,
        public display_mode:string,
        public icon:string,
        public code:string
    ){}    
}


// WEBPACK FOOTER //
// I:/Yog/Projects/Web/LetterDev/wwwroot/ManagerApp/wwwroot/src/app/shared/modules/crud/model/CrudListConfiguration.ts